<script setup lang="ts">
const { closeHelp } = useLayoutStore();

function onBack() {
  closeHelp();
}

function onClose() {
  closeHelp();
}
</script>

<template>
  <div class="flex flex-col">
    <!-- Top bar com Voltar e Fechar -->
    <div
      class="flex items-center justify-between px-3 py-2 md:px-4 md:py-3 bg-black/20"
    >
      <button
        class="flex items-center gap-2 rounded-lg px-2.5 py-1 bg-auth-button-bg text-auth-button-text"
        @click="onBack"
      >
        <NuxtIcon
          class="text-sm text-texts/30"
          name="arrows/arrow_left"
        />
        <span class="text-xs font-semibold">
          {{ $t('general.back') }}
        </span>
      </button>

      <BaseModalCloseButton
        class="text-white/60"
        is-inside-topbar
        @close="onClose"
      />
    </div>

    <!-- Conteúdo de ajuda -->
    <div class="p-4 md:p-6">
      <PagesHelp />
    </div>
  </div>
</template>
